export default "__VITE_ASSET__BeJB3CmW__"